import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import appointmentService from '../services/appointmentService';
import toast from 'react-hot-toast';

const AppointmentsPage = () => {
  const { user } = useSelector((state) => state.auth);
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAppointments();
  }, []);

  const fetchAppointments = async () => {
    try {
      setLoading(true);
      const response = await appointmentService.getAppointments({ userId: user._id });
      setAppointments(response.data);
    } catch (error) {
      toast.error('Failed to fetch appointments');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = async (appointmentId) => {
    if (window.confirm('Are you sure you want to cancel this appointment?')) {
      try {
        await appointmentService.cancelAppointment(appointmentId, 'Customer requested cancellation');
        toast.success('Appointment cancelled');
        fetchAppointments();
      } catch (error) {
        toast.error('Failed to cancel appointment');
      }
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold mb-8 dark:text-white">My Appointments</h1>

        {loading ? (
          <p className="text-center text-gray-600">Loading...</p>
        ) : appointments.length === 0 ? (
          <div className="card text-center">
            <p className="text-gray-600 dark:text-gray-400 mb-4">No appointments found</p>
            <a href="/booking" className="text-blue-600 hover:underline font-semibold">
              Book your first appointment
            </a>
          </div>
        ) : (
          <div className="space-y-4">
            {appointments.map((apt) => (
              <div key={apt._id} className="card">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                  <div>
                    <p className="text-sm text-gray-600 dark:text-gray-400">Service</p>
                    <p className="font-semibold dark:text-white">{apt.service?.name}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-600 dark:text-gray-400">Date & Time</p>
                    <p className="font-semibold dark:text-white">
                      {new Date(apt.appointmentDate).toLocaleDateString()} at {apt.startTime}
                    </p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-600 dark:text-gray-400">Status</p>
                    <span
                      className={`inline-block px-3 py-1 rounded-full text-sm font-semibold ${
                        apt.status === 'completed'
                          ? 'bg-green-100 text-green-800'
                          : apt.status === 'cancelled'
                          ? 'bg-red-100 text-red-800'
                          : 'bg-blue-100 text-blue-800'
                      }`}
                    >
                      {apt.status.charAt(0).toUpperCase() + apt.status.slice(1)}
                    </span>
                  </div>
                  <div className="flex space-x-2">
                    {apt.status === 'confirmed' && (
                      <>
                        <button
                          onClick={() => handleCancel(apt._id)}
                          className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition text-sm"
                        >
                          Cancel
                        </button>
                      </>
                    )}
                    {apt.status === 'completed' && (
                      <a href={`/appointment/${apt._id}/review`} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition text-sm">
                        Review
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AppointmentsPage;
